import { render, staticRenderFns } from "./Dashboard.vue?vue&type=template&id=200a7400&scoped=true&"
import script from "./Dashboard.vue?vue&type=script&lang=js&"
export * from "./Dashboard.vue?vue&type=script&lang=js&"
import style0 from "./Dashboard.vue?vue&type=style&index=0&id=200a7400&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "200a7400",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/c6monbi/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('200a7400')) {
      api.createRecord('200a7400', component.options)
    } else {
      api.reload('200a7400', component.options)
    }
    module.hot.accept("./Dashboard.vue?vue&type=template&id=200a7400&scoped=true&", function () {
      api.rerender('200a7400', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/monbi/Dashboard.vue"
export default component.exports